import React, { memo } from 'react';
import { handleCheckout } from '../utils/checkout';
export function FooterSection() {
  return <>
      {/* Final Offer Area */}
      <section className="bg-warm-mid py-20 md:py-24 px-4" data-id="element-135">
        <div className="max-w-lg mx-auto" data-id="element-136">
          <div className="bg-white rounded-2xl p-8 md:p-10 border border-soft-gold/25 shadow-xl text-center" data-id="element-137">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-hero mb-2" data-id="element-138">
              The Pawfect Shot MegaPack
            </h2>
            <p className="font-sans text-sm md:text-base text-gray-600 mb-8" data-id="element-139">
              6 Books + 3 Bonuses • Complete Phone Dog Photography System
            </p>

            <div className="mb-8" data-id="element-140">
              <p className="font-sans text-gray-500 text-lg mb-1" data-id="element-141">
                <span className="line-through text-red-400" data-id="element-142">NZD $89.99</span>
              </p>
              <p className="font-serif text-5xl md:text-6xl font-bold text-green-600" data-id="element-143">
                NZD $24.49
              </p>
            </div>

            <button onClick={handleCheckout} className="w-full bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-lg md:text-xl py-5 px-8 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase mb-5" data-id="element-144">
              👉 GET MY MEGAPACK NOW
            </button>

            <p className="font-sans text-sm text-gray-500 font-medium mb-3 flex flex-wrap items-center justify-center gap-3" data-id="element-145">
              <span data-id="element-146">🔒 Secure Checkout</span>
              <span data-id="element-147">⚡ Instant Access</span>
              <span data-id="element-148">✅ 7-Day Guarantee</span>
            </p>

            <p className="font-sans text-xs text-gray-400" data-id="element-149">
              Digital download • One-time payment • Lifetime access
            </p>
          </div>
        </div>
      </section>

      {/* Brand Closing Area */}
      <section className="bg-warm-light py-16 px-4 text-center border-t border-soft-gold/20" data-id="element-150">
        <div className="max-w-2xl mx-auto" data-id="element-151">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-warm-hero mb-4" data-id="element-152">
            The Pawfect Shot MegaPack
          </h3>
          <p className="font-sans text-base md:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-153">
            A simple, practical dog photography system for dog owners who want
            better photos, better memories, and more confidence using just their
            phone.
          </p>
          <p className="font-serif italic text-xl md:text-2xl text-soft-gold" data-id="element-154">
            Because your dog deserves more than random snapshots.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-warm-deep py-10 px-4 text-center border-t border-soft-gold/30" data-id="element-155">
        <div className="max-w-4xl mx-auto" data-id="element-156">
          <div className="font-sans text-sm text-warm-hero/80 space-x-4 md:space-x-6 mb-6 flex flex-wrap justify-center gap-y-3" data-id="element-157">
            <a href="mailto:support@thepawfectshot.com" className="hover:text-warm-hero transition-colors font-medium" data-id="element-158">
              soporte.nerovix@gmail.com
            </a>
            <span className="hidden md:inline" data-id="element-159">·</span>
            <a href="#" className="hover:text-warm-hero transition-colors font-medium" data-id="element-160">
              Privacy Policy
            </a>
            <span className="hidden md:inline" data-id="element-161">·</span>
            <a href="#" className="hover:text-warm-hero transition-colors font-medium" data-id="element-162">
              Terms and Conditions
            </a>
          </div>
          <p className="font-sans text-sm text-warm-hero/60" data-id="element-163">
            © 2026 The Pawfect Shot MegaPack. All rights reserved.
          </p>
        </div>
      </footer>
    </>;
}